var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-result',{attrs:{"status":"success","title":_vm.title,"sub-title":"We will get back to you soon with the details to setup your GLS site."}})}
var staticRenderFns = []

export { render, staticRenderFns }